<template>
  <main
    :class="`dark:bg-black dark:text-white ${
      meta.disableFooter() ? 'h-screen' : ''
    }`"
  >
    <Topbar v-if="!meta.isPageCourse() && !meta.isPageCourseTraditional()" />
    <TopbarCourse v-if="meta.isPageCourse() || meta.isPageCourseTraditional()" />
    <section
      :class="`${
        meta.hasContainer() ? 'container' : ''
      } mx-auto min-h-full overflow-x-hidden`"
    >
      <router-view v-slot="{ Component }">
        <transition name="scale" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </section>
    <FooterComponent v-if="meta.disableFooter()" />
    <Toast id="toast-message" position="bottom-left" />
  </main>
</template>

<script lang="ts">
import {
  createDetector,
  MediaPipeFaceMeshMediaPipeModelConfig,
  SupportedModels,
} from "@tensorflow-models/face-landmarks-detection";
import { defineComponent } from "vue";
import { AttentionService } from "./components/Attention/attention.service";
import { RouteMeta } from "./utils/metas.util";
import { Roles } from "./models/user.model";
import { getUserFromStorage } from "./utils/user-store.util";
import { RouteLocationNormalized } from "vue-router";

export default defineComponent({
  name: "App",
  computed: {
    meta(): RouteMeta {
      return new RouteMeta();
    },
  },
  mounted() {
    this.detectFaces();
  },
  watch: {
    $route(to) {
      window.scrollTo(0, 0);
      this.setTopbarForForum(to);
    },
  },
  methods: {
    async detectFaces<T>(): Promise<T> {
      const detectorConfig: MediaPipeFaceMeshMediaPipeModelConfig = {
        runtime: "mediapipe",
        solutionPath: "https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh",
        refineLandmarks: false,
      };

      AttentionService.detectorFaces.next(
        await createDetector(SupportedModels.MediaPipeFaceMesh, detectorConfig)
      );

      return AttentionService.detectorFaces.value;
    },
    setTopbarForForum(to: RouteLocationNormalized): void {
      if (to.meta.groupRouteFrom === "forum") {
        to.meta.pageCourse = Roles.STUDENT === getUserFromStorage()?.role;
      }
    },
  },
});
</script>

<style src="./app.scss" lang="scss" />
